import request from '@/utils/request'

const url = 'admin/ear_tag'
/**
 * 耳标管理表接口API
 */

const api = {
    Query(data) {
        return request({
          url: `${url}/list`,
          method: 'post',
          data
        })
    },
    
    /**
     * 添加EarTag
     * @returns
     */
    Create(data) {
        return request({
          url: `${url}/createOrUpdate`,
          method: 'post',
          data
        })
    },

    /**
     * 编辑EarTag
     * @returns
     */
    Update(data) {
        return request({
          url: `${url}/createOrUpdate`,
          method: 'post',
          data
        })
    },

    /**
     * 详情EarTag
     * @returns
     */
    Detail(id) {
        return request({
          url: `${url}/detail`,
          method: 'post',
          params: { id }
        })
    },

    /**
     * 删除EarTag
     * @returns
     */
    Delete(data) {
        return request({
          url: `${url}/destroy`,
          method: 'post',
          data
        })
    },

  /**
   * 更改EarTag数据
   * @returns
   */
  ChangeStatus(data) {
      return request({
        url: `${url}/changeStatus`,
        method: 'post',
        data
      })
  },


    /**
     * 修改EarTag数值数据，自增自减
     * @returns
     */
    NumberOperation(data) {
        return request({
          url: `${url}/numberOperation`,
          method: 'post',
          data
        })
    },

  /**
   * EarTag导入
   * @returns
   */
   Import(data) {
      return request({
        url: `${url}/import`,
        method: 'post',
        data
      })
   },

  /**
   * EarTag下载模板
   * @returns
   */
  downloadTemplate () {
    return request({
      url: `${url}/downloadTemplate`,
      method: 'post',
      responseType: 'blob'
    })
  },

  /**
   * 导出EarTag数据
   * @returns
   */
  Export(data) {
      return request({
        url: `${url}/export`,
        method: 'post',
        data
      })
  },


}

export default api
